import { useSuspenseQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'
import { useFlag } from '@/flags'

type ListingView = {
  date: Date
  count: number
}

interface Config {
  listingId: string
  period: string
}

export function useListingImpressions({
  listingId,
  period
}: Config) {
  const flag = useFlag('features.listing.impressions', false)
  return useSuspenseQuery({
    queryKey: ['insights', 'impressions', listingId, period],
    queryFn: () =>
      flag
        ? (client.get(`/stats/imp/listings/${listingId}/${period}`, {
            query: {
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }
          }) as Promise<ListingView[]>)
        : [],
    refetchInterval: 1000 * 60 * 5
  })
}
